module.exports = __webpack_public_path__ + "static/media/mcsnet-triangle-icon.62c86235.png";